/**
 * 封装 axios
 */
import axios from 'axios'
import qs from 'qs'
import store from '@/store/index';
const uploadAxios = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'http://xsbnew.tolinksoft.com/index.php/' : process.env.VUE_APP_HOST_DEV,
  method: 'post',
  timeout: 30000,
  // headers: {
  //   'Content-Type': 'multipart/form-data' //请求头
  // },
  // headers: { 'token': localStorage.getItem('token') },
  // 跨域请求，携带凭证。
  withCredentials: true,
  // 服务器相应数据类型
  // responseType: 'json',
  // retry:50,
  // retryDelay:1000,
  responseType: 'json',
  //发送前修改数据
  transformRequest: [function(data) {
    //发送请求传
    // data.token=sessionStorage.getItem('token')||'';
    data.token=localStorage.getItem('token')||'';
    data.uid=localStorage.getItem('uid')||'';
    // data.table_id=localStorage.getItem('tahu')||'';
    //qs模块对data数据转换
    return qs.stringify(data)
  }]
})

// 请求拦截
uploadAxios.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// // 返回拦截
// uploadAxios.interceptors.response.use(response => {
//   return response
// }, error => {
//   if (error.response.status === 500) {
//   } else if (error.response.status === 404) {
//   }
//   return Promise.reject(error)
// })
uploadAxios.install = (Vue) => {
  Vue.prototype.$uploadAxios = uploadAxios
}
export default uploadAxios



// WEBPACK FOOTER //
// ./src/assets/js/uploadAxios.js